import React from 'react';
import { withRouter, BrowserRouter, Route, Switch, Redirect } from 'react-router-dom';
import Login from './Pages/Login';
import Home from './Pages/Home';
import Expired from './Pages/Expired';
import Users from './Pages/Users';
import UsersMenu from './Pages/UsersMenu';
import BasicBook from './Pages/BasicBook';
import NewsPortal from './Pages/NewsPortal';
import KpiDashboard from './Pages/KpiDashboard';
import ProductDashboard from './Pages/ProductDashboard';
import MarketingDashboard from './Pages/MarketingDashboard';
import CustomerDashboard from './Pages/CustomerDashboard';
import NewsPortalAdd from './Pages/NewsPortalAdd';
import { getMenuToStorage } from './services/auth';
import { isAuthenticated } from '../src/services/auth';
import { EnviromentVars } from '../src/config/env';


const PrivateRoute = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={(props) =>
      isAuthenticated() ? (
        <Component {...props} />
      ) : (
        <Redirect to={{ pathname: '/', state: { from: props.location } }} />
      )
    }
  />
);

// const Routes = () => (
//   <BrowserRouter>
//     <Switch>
//       <Route path="/" exact component={Login} />
//       <Route path="/login" exact component={Login} />
//       <Route path="/expired" exact component={Expired} />
//       <PrivateRoute path="/marketing" exact component={()=>{
//         window.location.href = EnviromentVars.urlDirectFrontMarketing+'/home';
//         return null;
//       }} />
//       <PrivateRoute path="/operacional" exact component={()=>{
//         window.location.href = EnviromentVars.urlDirectFrontOperacional+'/home';
//         return null;
//       }} />
//       <PrivateRoute path="/home" component={Home} />
//       <PrivateRoute path="/users" component={Users} />
//       <PrivateRoute path="/usersmenu" component={UsersMenu} />
//       <PrivateRoute path="/basicbook" component={BasicBook} />
//       <PrivateRoute path="*" component={Home} />
//     </Switch>
//   </BrowserRouter>
// );

const paginas = [Login, Home, Expired, MarketingDashboard, KpiDashboard, ProductDashboard, CustomerDashboard, Users, UsersMenu, BasicBook, NewsPortal, NewsPortalAdd];

const Routes = () => (
  <BrowserRouter>
    <Switch>
      <Route path="/" exact component={Login} />
      <Route path="/:id" component={ComponenteDinamico} />
    </Switch>
  </BrowserRouter>
);

const ComponenteDinamico = ({ match }) => {
  const menus = getMenuToStorage();
  //
  //
  //
  //
  //
  //
  let Componente = undefined;
  if (paginas !== undefined) {
    for (const pagina of paginas) {
      if (
        (pagina.name !== undefined &&
          pagina.name.toUpperCase() ===
            String(match.params.id).toUpperCase()) ||
        (pagina.WrappedComponent !== undefined &&
          pagina.WrappedComponent.name.toUpperCase() ===
            String(match.params.id).toUpperCase())
      ) {
        Componente = pagina;
        break;
      }
    }

    if (Componente === undefined && menus !== undefined) {
      for (const menu of menus) {
        if (menu.DME_URL != null && menu.DME_URL.toUpperCase() === String(match.url).toUpperCase()) {
          let moduloDirectFront = menu.DME_CLASSE;
          return (<PrivateRoute path={menu.DME_URL} exact  component={(props)=>{
            window.location.href = EnviromentVars[moduloDirectFront]+menu.DME_URL;
            return null;
          }} />);
        }
      }
    }
    if (Componente === undefined) {
      Componente = Home;
    }
  }
  return Componente ? <PrivateRoute path={match.url} component={Componente} /> : "<error 404>";
};

export default withRouter(Routes);
